export default __webpack_public_path__ + "static/2-602cbdb522094d6962d24eb5b019bed9.jpg";